import React from 'react';

import { Filter } from '@gogame/filters';
import { usePages } from '@gogame/screens';

import {
  FILTER_APPLICATIONS,
  FILTER_PAGES,
  FILTER_ACTIONS,
  FILTER_COMPANIES,
  FILTER_MANAGERS,
  FILTER_DEPARTMENTS,
  FILTER_NETWORKS,
  FILTER_AFFILIATES,
  FILTER_STUDIOS,
  FILTER_SHOW,
} from 'scenes/Users/AdminUsers/constants';
import {
  loadApplications,
  loadActions,
  loadCompanies,
  loadManagers,
  loadDepartments,
  loadNetworks,
  loadAffiliates,
  loadStudios,
  loadFilterOptions,
} from 'scenes/Users/AdminUsers/sources/filters';

export const ShowCompanies = (props) => {
  return (
    <Filter.MultiSelect
      title={'Companies'}
      name={FILTER_COMPANIES}
      source={loadCompanies}
      placeholder={'All'}
      {...props}
    />
  );
};

export const ShowStudios = (props) => {
  return (
    <Filter.MultiSelect
      title={'Studios'}
      name={FILTER_STUDIOS}
      source={loadStudios}
      placeholder={'All'}
      {...props}
    />
  );
};
export const ShowDepartments = (props) => {
  return (
    <Filter.MultiSelect
      title={'Departments'}
      name={FILTER_DEPARTMENTS}
      source={loadDepartments}
      placeholder={'All'}
      {...props}
    />
  );
};

export const ShowManagers = (props) => {
  return (
    <Filter.MultiSelect
      title={'Managers'}
      name={FILTER_MANAGERS}
      source={loadManagers}
      placeholder={'All'}
      {...props}
    />
  );
};

export const ActionsFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Actions'}
      name={FILTER_ACTIONS}
      source={loadActions}
      placeholder={'All'}
      {...props}
    />
  );
};
export const PagesFilter = (props) => {
  const pages = usePages()?.map((page) => ({ id: page.id, name: page.title }));

  return (
    <Filter.MultiSelect
      title={'Pages'}
      name={FILTER_PAGES}
      placeholder={'All'}
      source={async () => pages}
      {...props}
    />
  );
};

export const ShowNetworks = (props) => {
  return (
    <Filter.MultiSelect
      title={'Networks'}
      name={FILTER_NETWORKS}
      source={loadNetworks}
      placeholder={'All'}
      {...props}
    />
  );
};
export const ShowAffiliates = (props) => {
  return (
    <Filter.MultiSelect
      title={'Affiliates'}
      name={FILTER_AFFILIATES}
      source={loadAffiliates}
      placeholder={'All'}
      {...props}
    />
  );
};

export const ApplicationsFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Applications'}
      name={FILTER_APPLICATIONS}
      source={loadApplications}
      placeholder={'All'}
      {...props}
    />
  );
};

export const ShowFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Show'}
      name={FILTER_SHOW}
      source={loadFilterOptions}
      placeholder={'All'}
      {...props}
    />
  );
};

export default {
  Companies: ShowCompanies,
  Studios: ShowStudios,
  Departments: ShowDepartments,
  Managers: ShowManagers,
  Actions: ActionsFilter,
  Pages: PagesFilter,
  Networks: ShowNetworks,
  Affiliates: ShowAffiliates,
  Applications: ApplicationsFilter,
  Show: ShowFilter,
};
